import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _CountriesVdos, _StatesCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { CountriesEditor } from "../CountriesEditor";

interface Props {
    idCountries: number;
}

export const StatesCatalog = ({ idCountries }: Props) => {

    const state = useDataBean(_StatesCatalog);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modalcities, setModalcities] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalstates, setModalstates] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idCountries, paginador.page])

    const getLista = () => {

        state.instance.getStatesCatalog(idCountries, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        state.setBean({
            IDCountries: idCountries
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        state.instance.deleteStates(state.bean.IDStates).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        state.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDStates', visible: true },
        { title: 'País', property: 'CountryName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo', property: 'TypeState', visible: true },
        { title: 'Latitud', property: 'Latitude', visible: true },
        { title: 'Longitud', property: 'Longitude', visible: true },
        { title: 'Código de Departamento', property: 'InternalStateCode', visible: true },
        { title: 'Código de Estado', property: 'StateCode', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Estados">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={state.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <CountriesEditor render={state.bean.CountryName} idSelector={state.bean.IDCountries} onChange={(e) => { state.setBean({ ...state.bean, "IDCountries": e.IDCountries, "CountryName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={state.bean.Name} onChange={(e) => { state.setBean({ ...state.bean, "Name": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Tipo</label>
                                <input type="text" name="TypeState" className="form-control" value={state.bean.TypeState} onChange={(e) => { state.setBean({ ...state.bean, "TypeState": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Latitud</label>
                                <input type="text" name="Latitude" className="form-control" value={state.bean.Latitude} onChange={(e) => { state.setBean({ ...state.bean, "Latitude": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Longitud</label>
                                <input type="text" name="Longitude" className="form-control" value={state.bean.Longitude} onChange={(e) => { state.setBean({ ...state.bean, "Longitude": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código de Departamento</label>
                                <input type="text" name="InternalStateCode" className="form-control" value={state.bean.InternalStateCode} onChange={(e) => { state.setBean({ ...state.bean, "InternalStateCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código de Estado</label>
                                <input type="text" name="StateCode" className="form-control" value={state.bean.StateCode} onChange={(e) => { state.setBean({ ...state.bean, "StateCode": e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {state.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}